// Active-response label keys: the source of truth for which Wazuh AR mechanisms we recognise. The value
// is the `labelKey` parseResponses produces — a mechanism, or mechanism:block / mechanism:unblock for
// stateful ones. Locales translate ACTIONS by these keys; unmapped mechanisms fall back to the raw
// rule description. Covers the Wazuh defaults plus org-specific custom scripts (e.g. eject-usb-macos).
// https://documentation.wazuh.com/current/user-manual/capabilities/active-response/default-active-response-scripts.html
export const ACTIVE_RESPONSE_KEYS = {
  ROUTE_NULL_BLOCK: 'route-null:block',
  ROUTE_NULL_UNBLOCK: 'route-null:unblock',
  WIN_ROUTE_NULL_BLOCK: 'win_route-null:block',
  WIN_ROUTE_NULL_UNBLOCK: 'win_route-null:unblock',
  FIREWALL_DROP_BLOCK: 'firewall-drop:block',
  FIREWALL_DROP_UNBLOCK: 'firewall-drop:unblock',
  PF_BLOCK: 'pf:block',
  PF_UNBLOCK: 'pf:unblock',
  NPF_BLOCK: 'npf:block',
  NPF_UNBLOCK: 'npf:unblock',
  IPFW_BLOCK: 'ipfw:block',
  IPFW_UNBLOCK: 'ipfw:unblock',
  NETSH_BLOCK: 'netsh:block',
  NETSH_UNBLOCK: 'netsh:unblock',
  HOST_DENY_BLOCK: 'host-deny:block',
  HOST_DENY_UNBLOCK: 'host-deny:unblock',
  DISABLE_ACCOUNT: 'disable-account',
  RESTART_WAZUH: 'restart-wazuh',
  EJECT_USB_MACOS: 'eject-usb-macos',
} as const

export type IActiveResponseKey = (typeof ACTIVE_RESPONSE_KEYS)[keyof typeof ACTIVE_RESPONSE_KEYS]
